// extracted by mini-css-extract-plugin
module.exports = {"LocaleSwitcher":"intl_LocaleSwitcher__2Ci1E","Link":"intl_Link__NdRuv undefined Button_Primary__1iyhk Button_Common__Ufb7z"};